var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23270_85575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23270_85575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 13C5.3731 13 5 12.6269 5 12.1667C5 11.7064 5.3731 11.3333 5.83333 11.3333H8.16667C8.6269 11.3333 9 11.7064 9 12.1667C9 12.6269 8.6269 13 8.16667 13H5.83333ZM2.83333 8.83333C2.3731 8.83333 2 8.46024 2 8C2 7.53976 2.3731 7.16667 2.83333 7.16667H11.1667C11.6269 7.16667 12 7.53976 12 8C12 8.46024 11.6269 8.83333 11.1667 8.83333H2.83333ZM0.833334 4.66667C0.373097 4.66667 0 4.29357 0 3.83333C0 3.3731 0.373096 3 0.833333 3H13.1667C13.6269 3 14 3.3731 14 3.83333C14 4.29357 13.6269 4.66667 13.1667 4.66667H0.833334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.d2b718c66c399e127757e7244a926426.svg";
export { ForwardRef as ReactComponent };